import React from 'react';
import { Spinner } from '@ui-kitten/components';
const DNASpinner = (props) => {
    return (<Spinner {...props}/>);
};
DNASpinner.displayName = 'DNASpinner';
export default DNASpinner;
//# sourceMappingURL=DNASpinner.js.map